import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/bankid.svg'


const _withScopeId = n => (_pushScopeId("data-v-c915e0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-info text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "alert alert-info text-center"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Logga in och verifiera mig som ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("xxxx ")
const _hoisted_5 = {
  key: 2,
  class: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Logga in och verifiera mig som:", -1))
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "form-check-label" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("xxxx ")
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "form-check-label" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("xxxx ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"display":"block","width":"80px","margin":"0 auto"},
    src: _imports_0
  })
], -1))
const _hoisted_14 = {
  key: 3,
  class: "row py-4"
}
const _hoisted_15 = { class: "col-sm-6 d-grid" }
const _hoisted_16 = { class: "col-sm-6 d-grid" }
const _hoisted_17 = {
  key: 0,
  style: {"margin":"0 auto"}
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Gick inte att logga in", -1))
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Gick inte att logga in", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" BankID-programmet verkar inte finnas på din dator eller telefon. Installera det och hämta ett BankID hos din internetbank. Installera programmet från "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://install.bankid.com" }, "install.bankid.com"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BankIdForm = _resolveComponent("BankIdForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Laddar... "))
      : _createCommentVNode("", true),
    (_ctx.applicants.applicantId && !_ctx.applicants.coApplicantId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _hoisted_3,
            _createElementVNode("strong", null, _toDisplayString(_ctx.applicants.applicantPersonalNumberDate), 1),
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.applicants.applicantId && _ctx.applicants.coApplicantId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signAsCoApplicant = false)),
            class: "form-check"
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: !_ctx.signAsCoApplicant,
              class: "form-check-input"
            }, null, 8, _hoisted_7),
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.applicants.applicantPersonalNumberDate), 1),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signAsCoApplicant = true)),
            class: "form-check"
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.signAsCoApplicant,
              class: "form-check-input"
            }, null, 8, _hoisted_10),
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.applicants.coApplicantPersonalNumberDate), 1),
              _hoisted_12
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-lg btn-light mb-3", { selected: _ctx.chosenDevice == 'mobile' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.chosenDevice = 'mobile'))
            }, " Mobilt BankID ", 2)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-lg btn-light mb-3", { selected: _ctx.chosenDevice == 'other' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chosenDevice = 'other'))
            }, " BankID på fil eller kort ", 2)
          ]),
          (_ctx.chosenDevice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _withDirectives(_createVNode(_component_BankIdForm, {
                  chosenDevice: _ctx.chosenDevice,
                  onStart: _ctx.start,
                  showPersonalNumber: !_ctx.applicants.applicantId
                }, null, 8, ["chosenDevice", "onStart", "showPersonalNumber"]), [
                  [_vShow, _ctx.status == 'init']
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.status == 'pending' || _ctx.status == 'start')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_ctx.status == 'start')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Startar upp..."))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, _toDisplayString(_ctx.userMessage), 1),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, " Avbryt inloggning ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.status == 'complete')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Du loggas nu in"))
        : _createCommentVNode("", true),
      (_ctx.status === 'failed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", null, _toDisplayString(_ctx.userMessage), 1),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, "Försök igen")
          ]))
        : _createCommentVNode("", true),
      (_ctx.status === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
              }, "Försök igen")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}